(() => {
  'use strict';
  try {
    if (window.MiniCubezDiagnostics) return;
    const release = 'custom-car-20261014-observability-r2';
    const script = document.querySelector('[data-mc-diagnostics-script]');
    const theme = /^\d{6,20}$/.test(script?.dataset.mcTheme || '') ? script.dataset.mcTheme : 'local';
    const environment = location.hostname === 'localhost' ? 'local' : window.Shopify?.theme?.role === 'main' || window.Shopify?.theme?.role === 'live' ? 'live' : 'preview';
    const browser = /Instagram/i.test(navigator.userAgent) ? 'instagram' : /FBAN|FBAV/i.test(navigator.userAgent) ? 'facebook' : /iPhone|iPad/i.test(navigator.userAgent) ? 'ios' : 'other';
    const events = new Set(('page_view builder_ready order_cta order_open order_close order_retry order_reset step_view addon_on addon_off policy_accepted photos_ready validation_blocked photo_selected photo_invalid photo_removed photo_retry photo_paused upload_started upload_complete upload_failed upload_slow api_retry api_failed cart_attempt commit_complete cart_verified cart_open cart_failed cart_slow cart_update cart_updated cart_update_failed cart_incomplete checkout_click checkout_submit reviews_click videos_click instagram_view video_play video_failed section_view offline online page_return entry_failed builder_failed runtime_error unhandled_rejection asset_failed preview_failed external_runtime_error').split(' '));
    const failures = new Set(['entry_failed','builder_failed','upload_failed','api_failed','cart_failed','cart_update_failed','cart_incomplete','runtime_error','unhandled_rejection','asset_failed','video_failed']);
    const warnings = new Set(['upload_slow','cart_slow','preview_failed','external_runtime_error']);
    const enums = {
      slot: ['front','rear','left','right','plate','extra','bulk','extras'],
      step: ['photos','extras','review','cart'],
      provider: ['easify','drive'],
      stage: ['entry','initialize','selection','upload','commit','cart_sync','cart_module','cart_drawer','cart_update','checkout','runtime','media'],
      reason: ['single_photo','empty_photo','file_size','unreadable_photo','bad_format','bulk_limit','extra_limit','invalid_image','photo_mismatch','easify_receipt','easify_unavailable','upload_busy','missing_upload','invalid_session','preview_only','storage_unavailable','drive_connection','drive_privacy','draft_upload_limit','idempotency_conflict','unavailable','network','timeout','http','unknown','module','ack_required','busy_uploads','incomplete_photos'],
      operation: ['draft','reserve','resume','verify','upload','commit','other'],
      size: ['under_1mb','1_to_5mb','5_to_10mb','over_10mb'],
      mime: ['image/jpeg','image/png','image/webp','image/avif','image/heic','image/heif','image/tiff','unknown'],
      elapsed: ['under_5s','5_to_15s','15_to_45s','over_45s'],
      source: ['mc-customizer.js','mc-mobile-builder.js','mc-order-entry.js','mc-cart-sync.js','mc-cart-groups.js','mc-instagram-carousel.js','mc-section-scroll.js','mc-diagnostics.js','product-form.js','cart.js','cart-drawer.js','global.js','inline','external'],
      error_type: ['Error','TypeError','ReferenceError','SyntaxError','RangeError','SecurityError','NotSupportedError','InvalidStateError','AbortError','unknown'],
      section: ['mc-builder','mc-story','mc-included','mc-ordering','mc-specs','mc-videos','mc-instagram-posts','mc-reviews','mc-faq'],
      addon: ['plate','priority','stand','display','workshop','gas','other']
    };
    const ring = [], pending = [], counts = new Map(), tags = new Set(), watches = new Set();
    let scheduled = false, poll, polls = 0, normalCount = 0, failureCount = 0, upgraded = false;
    const safe = action => { try { return action(); } catch { return undefined; } };
    const clean = input => {
      const result = {};
      if (!input || typeof input !== 'object') return result;
      for (const [key, values] of Object.entries(enums)) if (values.includes(input[key])) result[key] = input[key];
      for (const key of ['http','attempt','line','column','ready']) {
        const value = input[key], max = key === 'http' ? 599 : key === 'ready' ? 4 : key === 'attempt' ? 100 : 100000;
        if (Number.isSafeInteger(value) && value >= 0 && value <= max) result[key] = value;
      }
      return result;
    };
    const consentAllowed = () => {
      const privacy = window.Shopify?.customerPrivacy;
      return !privacy?.analyticsProcessingAllowed || privacy.analyticsProcessingAllowed() !== false;
    };
    function setTag(key, value) {
      const signature = key + ':' + value;
      if (tags.has(signature)) return;
      window.clarity('set', key, String(value)); tags.add(signature);
    }
    function flush() {
      scheduled = false;
      safe(() => {
        if (!consentAllowed()) { pending.length = 0; document.documentElement.dataset.mcClarityState = 'consent_denied'; return; }
        if (typeof window.clarity !== 'function') {
          document.documentElement.dataset.mcClarityState = 'waiting';
          if (!poll && polls++ < 30) poll = setTimeout(() => { poll = null; flush(); }, 2000);
          return;
        }
        document.documentElement.dataset.mcClarityState = 'available';
        setTag('mc_experience', 'custom_car_v2'); setTag('mc_release', release); setTag('mc_environment', environment); setTag('mc_theme', theme); setTag('mc_browser', browser);
        for (const item of pending.splice(0)) safe(() => {
          if (item.step) setTag('mc_step', item.step);
          if (failures.has(item.event) || warnings.has(item.event)) {
            setTag('mc_issue', item.event); setTag('mc_has_issue', 'yes');
            if (item.stage) setTag('mc_issue_stage', item.stage);
            if (item.reason) setTag('mc_issue_reason', item.reason);
            if (item.slot) setTag('mc_issue_slot', item.slot);
            if (item.http) setTag('mc_http', item.http);
            if (item.source) setTag('mc_error_source', item.source + (item.line ? ':' + item.line + ':' + (item.column || 0) : ''));
            if (item.error_type) setTag('mc_error_type', item.error_type);
            if (!upgraded && failures.has(item.event)) { window.clarity('upgrade', 'mc_order_issue'); upgraded = true; }
          }
          window.clarity('event', 'mc_' + item.event);
          if (item.event === 'step_view' && item.step) window.clarity('event', 'mc_step_' + item.step);
          if (['upload_started','upload_complete','upload_failed'].includes(item.event) && item.slot) window.clarity('event', 'mc_upload_' + item.slot + '_' + item.event.slice(7));
        });
      });
    }
    function schedule() { if (!scheduled) { scheduled = true; setTimeout(flush, 0); } }
    function record(event, input) {
      return safe(() => {
        if (!events.has(event)) return;
        const context = clean(input), failure = failures.has(event), key = event + ':' + (context.slot || '') + ':' + (context.reason || '') + ':' + (context.source || '');
        const count = counts.get(key) || 0;
        if (count >= (failure ? 3 : 24) || (failure ? failureCount >= 40 : normalCount >= 180)) return;
        counts.set(key, count + 1); if (failure) failureCount++; else normalCount++;
        const item = {event, ...context, release, theme, environment, browser, online: navigator.onLine !== false};
        ring.push(item); if (ring.length > 96) ring.shift();
        document.documentElement.dataset.mcDiagnosticEvent = event;
        document.documentElement.dataset.mcDiagnosticCount = String(normalCount + failureCount);
        if (failure || warnings.has(event)) safe(() => console[failure ? 'error' : 'warn']('[MiniCubez custom-car] MC_' + event.toUpperCase(), item));
        if (consentAllowed()) {
          if (pending.length >= 64) { const index = pending.findIndex(entry => !failures.has(entry.event)); pending.splice(index < 0 ? 0 : index, 1); }
          pending.push(item); schedule();
        }
      });
    }
    function watch(operation, input) {
      let timer, finished = false;
      const stop = () => { finished = true; clearTimeout(timer); watches.delete(stop); };
      safe(() => {
        if (!['upload','cart'].includes(operation) || watches.size >= 16) return;
        watches.add(stop);
        timer = setTimeout(() => {
          if (!finished && document.visibilityState === 'visible' && navigator.onLine !== false) record(operation + '_slow', input);
        }, operation === 'upload' ? 45000 : 25000);
      });
      return stop;
    }
    function sourceOf(value) {
      const match = String(value || '').match(/(?:^|\/)(mc-[a-z-]+\.js|product-form\.js|cart\.js|cart-drawer\.js|global\.js)(?:[?:]|$)/);
      if (match && enums.source.includes(match[1])) return match[1];
      try { const url = new URL(value, location.href); if (value && url.origin === location.origin && url.pathname === location.pathname) return 'inline'; } catch {}
      return 'external';
    }
    const listen = (target, type, handler, options) => target.addEventListener(type, event => safe(() => handler(event)), options);
    window.MiniCubezDiagnostics = Object.freeze({record, watch, snapshot: () => safe(() => ring.map(item => ({...item}))) || []});
    document.documentElement.dataset.mcDiagnostics = release;
    listen(window, 'error', event => {
      if (event.target?.tagName === 'SCRIPT' || event.target?.tagName === 'LINK') {
        const source = sourceOf(event.target.src || event.target.href);
        if (source !== 'external') record('asset_failed', {stage:'runtime', source});
        return;
      }
      if (event.target?.tagName === 'IMG' && event.target.closest('mc-customizer,mc-cart-group')) { record('preview_failed', {stage:'media'}); return; }
      if (!event.message && !event.error) return;
      const source = sourceOf(event.filename);
      record(source === 'external' ? 'external_runtime_error' : 'runtime_error', {stage:'runtime', source, line:event.lineno, column:event.colno, error_type:event.error?.name});
    }, true);
    listen(window, 'unhandledrejection', event => {
      if (event.reason?.name === 'AbortError') return;
      const stack = String(event.reason?.stack || ''), frame = stack.split('\n').find(line => /\/mc-[a-z-]+\.js/.test(line));
      const match = frame?.match(/(mc-[a-z-]+\.js)(?:\?[^\s):]*)?:(\d+):(\d+)/);
      record(match ? 'unhandled_rejection' : 'external_runtime_error', {stage:'runtime', source:match?.[1] || 'external', line:match ? Number(match[2]) : undefined, column:match ? Number(match[3]) : undefined, error_type:event.reason?.name});
    });
    listen(window, 'offline', () => record('offline'));
    listen(window, 'online', () => record('online'));
    listen(window, 'pageshow', event => { if (event.persisted) record('page_return'); });
    listen(window, 'pagehide', () => { for (const stop of watches) stop(); flush(); });
    listen(document, 'visitorConsentCollected', () => { tags.clear(); schedule(); });
    listen(window, 'click', event => {
      const target = event.target.closest?.('a,button'); if (!target) return;
      const hash = target.tagName === 'A' ? new URL(target.href, location.href).hash : '';
      if (hash === '#mc-builder') record('order_cta', {stage:'entry'});
      if (hash === '#mc-reviews') record('reviews_click');
      if (hash === '#mc-videos') record('videos_click');
      if (target.matches('[name="checkout"],a[href="/checkout"]') && document.querySelector('mc-cart-group')) record('checkout_click', {stage:'checkout',step:'cart'});
      if (target.closest('#mc-instagram-posts')) record('instagram_view');
    }, {capture:true,passive:true});
    listen(document, 'submit', event => {
      if (event.submitter?.name === 'checkout' && document.querySelector('mc-cart-group')) queueMicrotask(() => safe(() => { if (!event.defaultPrevented) record('checkout_submit', {stage:'checkout',step:'cart'}); }));
    }, {passive:true});
    listen(document, 'play', event => { if (event.target.closest?.('[id^="mc-"],.mvr-section')) record('video_play', {stage:'media'}); }, true);
    listen(document, 'error', event => { if (event.target.tagName === 'VIDEO' && event.target.closest('[id^="mc-"],.mvr-section')) record('video_failed', {stage:'media'}); }, true);
    if (typeof IntersectionObserver === 'function') {
      const observer = new IntersectionObserver(entries => safe(() => {
        for (const entry of entries) if (entry.isIntersecting) { record('section_view', {section:entry.target.id}); observer.unobserve(entry.target); }
      }), {threshold:0.1});
      for (const id of enums.section) { const section = document.getElementById(id); if (section) observer.observe(section); }
    }
    record('page_view');
  } catch {}
})();
